import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgDangerDriveService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    getListRuleType(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/danger/drive";
        url += "/rule/type/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListRuleConfig(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/danger/drive";
        url += "/rule/config/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":"1"
        //     ,"dtgDriveRuleType":1
        //     ,"dtgCarType":"11"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListDangerDriveHis(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/danger/drive";
        url += "/his/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":"0"
        //     ,"dtgDriveRuleType":102
        //     ,"searchDateFrom":"2020-01-01 00:00:00"
        //     ,"searchDateTo":"2020-01-01 23:59:59"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListDangerDriveHisDetail(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/danger/drive";
        url += "/his/detail/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":"0"
        //     ,"dtgDriveRuleType":102
        //     ,"dtgUnitId":"01229522504"
        //     ,"fvmsTripCnt":"1597294897"
        //     ,"dtgRegDtFrom":"2020-01-01 23:59:59"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }
}